export default __webpack_public_path__ + "static/media/ahmed_1.2d63aca1.jpg";